import React, { useContext, useEffect, useState } from "react";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";

import { Container, Menu, Image, Icon, Grid, Button, Label } from "semantic-ui-react";
import { GetUser, Logout, TimeRemeaning, IsExpired } from "../../services/auth";

import logo from "../../assets/logo_branca.png";
import ModalYesNo from "../ModalYesNo";
import { IMenuContextState, MenuContext } from "./MenuContext";
import { toast } from "react-toastify";

interface IProps extends RouteComponentProps {

}

interface IState {
    display: string;
}

const initialState: IState = {
    display: "none"
}

function AliancaMenu({ history }: IProps) {
    const menuContext = useContext<IMenuContextState>(MenuContext);

    const [state, setState] = useState<IState>(initialState);
    const [seconds, setSeconds] = useState<number>(10);

    useEffect(() => {
        menuContext.loadNotifications();
    }, []);

    const handleToggleDropdownMenu = () => {
        if (state.display === "none") setState(state => ({ ...state, display: "flex" }));
        else setState(state => ({ ...state, display: "none" }));
    };

    const Deslogar = () => {
        Logout();
        history.push("/");
    }

    const ModalDeslogar = (
        <ModalYesNo
            header={"Sair"}
            content={"Tem certeza que deseja sair?"}
            onSuccess={Deslogar}
            trigger={
                <Menu.Item as="a">
                    <Icon name="log out" />
                    Sair
                </Menu.Item>
            }
        />
    );

    const Notificacoes = (
        <>
            {GetUser().role !== "Admin" &&
                <Menu.Item>
                    <Button as={Link}
                        circular
                        icon
                        to="/user/notifications"
                        loading={menuContext.notificationsLoading}
                    >
                        <Icon name="bell" />
                        {menuContext.notificationsCount > 0 &&
                            <Label
                                floating
                                color="blue"
                                content={menuContext.notificationsCount}
                                size="small"
                            />
                        }
                    </Button>
                </Menu.Item>
            }
        </>
    );

    const renewSession = () => {
        return toast(`⌛ Sessão renovada com sucesso. `, { position: "top-center", type: "success" });
    }

    const remeaningMinutes = () => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
            return TimeRemeaning();
        } else {
            setSeconds(10);
        }
    }

    const setColor = () => {
        if (GetUser().role === "GerenteR") {
            return "black";
        }
        if (GetUser().role === "GerenteS") {
            return "pink";
        }
        if (GetUser().role === "Representante") {
            return "purple";
        }
        else {
            return "black";
        }
    }

    const ModalRenew = (
        <ModalYesNo
            header={"Renovar Sessão"}
            content={"Deseja renovar a sessão atual?"}
            onSuccess={renewSession}
            trigger={
                <Menu.Item>
                    <Label
                        color={TimeRemeaning() <= 15 ? "red" : setColor()}
                    >
                        Sua sessão expira<br />
                        em: {remeaningMinutes()} minuto(s)
                    </Label>
                </Menu.Item>
            }
        />
    )

    return (
        <>
            <Grid padded className="tablet computer only">
                <Menu inverted fixed="top" color={setColor()}>
                    <Container>
                        <Menu.Item as={Link} to="/app">
                            <Image
                                size="small"
                                src={logo}
                            />
                        </Menu.Item>
                        <Menu.Item as={Link} to="/production">
                            Produção
                        </Menu.Item>
                        <Menu.Item as={Link} to="/control">
                            Controle
                        </Menu.Item>
                        <Menu.Item as={Link} to="/report">
                            Relatórios
                        </Menu.Item>
                        {/* <Menu.Item as={Link} to="/redessociais">
                            Redes Sociais
                        </Menu.Item> */}
                        <Menu.Item>
                            <Button
                                circular
                                as="a"
                                color="green"
                                icon="whatsapp"
                                href="https://api.whatsapp.com/send?phone=5511940574795&text=Ol%C3%A1"
                            />
                        </Menu.Item>
                        <Menu.Menu position="right">
                            <Menu.Item as={Link} to="/user/profile">
                                <Label size="large" color={setColor()}>
                                    Olá, <br />{GetUser().nome.split(" ")[0]}
                                </Label>
                            </Menu.Item>
                            {Notificacoes}
                            {/* {ModalRenew} */}
                            {ModalDeslogar}
                        </Menu.Menu>
                    </Container>
                </Menu>
            </Grid>
            <Grid className="mobile only">
                <Menu inverted size="huge" fixed="top" color={setColor()}>
                    <Menu.Item as={Link} to="/app">
                        <Image
                            size="small"
                            src={logo}
                        />
                    </Menu.Item>
                    <Menu.Menu position="right">
                        {Notificacoes}
                        <Menu.Item>
                            <Button
                                icon
                                toggle
                                onClick={handleToggleDropdownMenu}
                            >
                                <Icon name="content" />
                            </Button>
                        </Menu.Item>
                    </Menu.Menu>
                    <Menu vertical inverted fluid style={{ display: state.display }}>
                        <Menu.Item as={Link} to="/user/profile">
                            Olá, {GetUser().nome.split(" ")[0]}
                        </Menu.Item>
                        <Menu.Item as={Link} to="/production">
                            Produção
                        </Menu.Item>
                        <Menu.Item as={Link} to="/control">
                            Controle
                        </Menu.Item>
                        <Menu.Item as={Link} to="/report">
                            Relatórios
                        </Menu.Item>
                        {/* <Menu.Item as={Link} to="/redessociais">
                            Redes Sociais
                        </Menu.Item> */}
                        <Menu.Item>
                            <Button
                                as="a"
                                color="green"
                                icon="whatsapp"
                                href="https://api.whatsapp.com/send?phone=5511940574795&text=Ol%C3%A1"
                                content="CONTATO"
                            />
                        </Menu.Item>
                        {ModalDeslogar}
                    </Menu>
                </Menu>
            </Grid>
        </>
    );
};

export default withRouter(AliancaMenu);
